/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditPaymentMethodBodyBody,
    GetPaymentMethodsParams,
    PaymentMethodCreateSuccessResponseResponse,
    PaymentMethodSuccessResponseResponse,
    PaymentMethodsSuccessResponseResponse,
    PublicConnectOnboarding200,
    PublicConnectOnboardingBody,
    RequestStatusResponseResponse,
    SetupStripeConnect200,
    SetupStripeConnectBody,
    TogglePaymentMethodBodyBody,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new payment method
 */
export const addPaymentMethod = (
    venueId: number,
    addEditPaymentMethodBodyBody: AddEditPaymentMethodBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<PaymentMethodCreateSuccessResponseResponse>({
        url: `/paymentmethods/${venueId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditPaymentMethodBodyBody,
        signal,
    });
};

export const getAddPaymentMethodMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addPaymentMethod>>,
        TError,
        { venueId: number; data: AddEditPaymentMethodBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addPaymentMethod>>,
    TError,
    { venueId: number; data: AddEditPaymentMethodBodyBody },
    TContext
> => {
    const mutationKey = ['addPaymentMethod'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addPaymentMethod>>,
        { venueId: number; data: AddEditPaymentMethodBodyBody }
    > = (props) => {
        const { venueId, data } = props ?? {};

        return addPaymentMethod(venueId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddPaymentMethodMutationResult = NonNullable<
    Awaited<ReturnType<typeof addPaymentMethod>>
>;
export type AddPaymentMethodMutationBody = AddEditPaymentMethodBodyBody;
export type AddPaymentMethodMutationError = APIErrorResponseResponse;

/**
 * @summary Add new payment method
 */
export const useAddPaymentMethod = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addPaymentMethod>>,
        TError,
        { venueId: number; data: AddEditPaymentMethodBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addPaymentMethod>>,
    TError,
    { venueId: number; data: AddEditPaymentMethodBodyBody },
    TContext
> => {
    const mutationOptions = getAddPaymentMethodMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get payment methods matching the filters
 */
export const getPaymentMethods = (
    venueId: number,
    params?: GetPaymentMethodsParams,
    signal?: AbortSignal,
) => {
    return customInstance<PaymentMethodsSuccessResponseResponse>({
        url: `/paymentmethods/${venueId}`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetPaymentMethodsQueryKey = (
    venueId?: number,
    params?: GetPaymentMethodsParams,
) => {
    return [`/paymentmethods/${venueId}`, ...(params ? [params] : [])] as const;
};

export const getGetPaymentMethodsQueryOptions = <
    TData = Awaited<ReturnType<typeof getPaymentMethods>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetPaymentMethodsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethods>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPaymentMethodsQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentMethods>>> = ({ signal }) =>
        getPaymentMethods(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethods>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetPaymentMethodsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPaymentMethods>>
>;
export type GetPaymentMethodsQueryError = APIErrorResponseResponse;

/**
 * @summary Get payment methods matching the filters
 */

export function useGetPaymentMethods<
    TData = Awaited<ReturnType<typeof getPaymentMethods>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetPaymentMethodsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethods>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetPaymentMethodsQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get payment method by id
 */
export const getPaymentMethod = (venueId: number, id: number, signal?: AbortSignal) => {
    return customInstance<PaymentMethodSuccessResponseResponse>({
        url: `/paymentmethods/${venueId}/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetPaymentMethodQueryKey = (venueId?: number, id?: number) => {
    return [`/paymentmethods/${venueId}/${id}`] as const;
};

export const getGetPaymentMethodQueryOptions = <
    TData = Awaited<ReturnType<typeof getPaymentMethod>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPaymentMethodQueryKey(venueId, id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentMethod>>> = ({ signal }) =>
        getPaymentMethod(venueId, id, signal);

    return { queryKey, queryFn, enabled: !!(venueId && id), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethod>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetPaymentMethodQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentMethod>>>;
export type GetPaymentMethodQueryError = APIErrorResponseResponse;

/**
 * @summary Get payment method by id
 */

export function useGetPaymentMethod<
    TData = Awaited<ReturnType<typeof getPaymentMethod>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetPaymentMethodQueryOptions(venueId, id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit payment method
 */
export const editPaymentMethod = (
    venueId: number,
    id: number,
    addEditPaymentMethodBodyBody: AddEditPaymentMethodBodyBody,
) => {
    return customInstance<PaymentMethodSuccessResponseResponse>({
        url: `/paymentmethods/${venueId}/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditPaymentMethodBodyBody,
    });
};

export const getEditPaymentMethodMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editPaymentMethod>>,
        TError,
        { venueId: number; id: number; data: AddEditPaymentMethodBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editPaymentMethod>>,
    TError,
    { venueId: number; id: number; data: AddEditPaymentMethodBodyBody },
    TContext
> => {
    const mutationKey = ['editPaymentMethod'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editPaymentMethod>>,
        { venueId: number; id: number; data: AddEditPaymentMethodBodyBody }
    > = (props) => {
        const { venueId, id, data } = props ?? {};

        return editPaymentMethod(venueId, id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditPaymentMethodMutationResult = NonNullable<
    Awaited<ReturnType<typeof editPaymentMethod>>
>;
export type EditPaymentMethodMutationBody = AddEditPaymentMethodBodyBody;
export type EditPaymentMethodMutationError = APIErrorResponseResponse;

/**
 * @summary Edit payment method
 */
export const useEditPaymentMethod = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editPaymentMethod>>,
        TError,
        { venueId: number; id: number; data: AddEditPaymentMethodBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editPaymentMethod>>,
    TError,
    { venueId: number; id: number; data: AddEditPaymentMethodBodyBody },
    TContext
> => {
    const mutationOptions = getEditPaymentMethodMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete payment method by id
 */
export const deletePaymentMethod = (venueId: number, id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/paymentmethods/${venueId}/${id}`,
        method: 'DELETE',
    });
};

export const getDeletePaymentMethodMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deletePaymentMethod>>,
        TError,
        { venueId: number; id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deletePaymentMethod>>,
    TError,
    { venueId: number; id: number },
    TContext
> => {
    const mutationKey = ['deletePaymentMethod'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deletePaymentMethod>>,
        { venueId: number; id: number }
    > = (props) => {
        const { venueId, id } = props ?? {};

        return deletePaymentMethod(venueId, id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeletePaymentMethodMutationResult = NonNullable<
    Awaited<ReturnType<typeof deletePaymentMethod>>
>;

export type DeletePaymentMethodMutationError = APIErrorResponseResponse;

/**
 * @summary Delete payment method by id
 */
export const useDeletePaymentMethod = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deletePaymentMethod>>,
        TError,
        { venueId: number; id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deletePaymentMethod>>,
    TError,
    { venueId: number; id: number },
    TContext
> => {
    const mutationOptions = getDeletePaymentMethodMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Edit payment method (enable/disable)
 */
export const togglePaymentMethod = (
    venueId: number,
    id: number,
    togglePaymentMethodBodyBody: TogglePaymentMethodBodyBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/paymentmethods/${venueId}/${id}/toggle`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: togglePaymentMethodBodyBody,
    });
};

export const getTogglePaymentMethodMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof togglePaymentMethod>>,
        TError,
        { venueId: number; id: number; data: TogglePaymentMethodBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof togglePaymentMethod>>,
    TError,
    { venueId: number; id: number; data: TogglePaymentMethodBodyBody },
    TContext
> => {
    const mutationKey = ['togglePaymentMethod'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof togglePaymentMethod>>,
        { venueId: number; id: number; data: TogglePaymentMethodBodyBody }
    > = (props) => {
        const { venueId, id, data } = props ?? {};

        return togglePaymentMethod(venueId, id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type TogglePaymentMethodMutationResult = NonNullable<
    Awaited<ReturnType<typeof togglePaymentMethod>>
>;
export type TogglePaymentMethodMutationBody = TogglePaymentMethodBodyBody;
export type TogglePaymentMethodMutationError = APIErrorResponseResponse;

/**
 * @summary Edit payment method (enable/disable)
 */
export const useTogglePaymentMethod = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof togglePaymentMethod>>,
        TError,
        { venueId: number; id: number; data: TogglePaymentMethodBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof togglePaymentMethod>>,
    TError,
    { venueId: number; id: number; data: TogglePaymentMethodBodyBody },
    TContext
> => {
    const mutationOptions = getTogglePaymentMethodMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Setup Stripe Connect for a payment method
 */
export const setupStripeConnect = (
    venueId: number,
    id: number,
    setupStripeConnectBody: SetupStripeConnectBody,
    signal?: AbortSignal,
) => {
    return customInstance<SetupStripeConnect200>({
        url: `/venues/${venueId}/payment-methods/${id}/stripe-connect`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: setupStripeConnectBody,
        signal,
    });
};

export const getSetupStripeConnectMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setupStripeConnect>>,
        TError,
        { venueId: number; id: number; data: SetupStripeConnectBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof setupStripeConnect>>,
    TError,
    { venueId: number; id: number; data: SetupStripeConnectBody },
    TContext
> => {
    const mutationKey = ['setupStripeConnect'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof setupStripeConnect>>,
        { venueId: number; id: number; data: SetupStripeConnectBody }
    > = (props) => {
        const { venueId, id, data } = props ?? {};

        return setupStripeConnect(venueId, id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetupStripeConnectMutationResult = NonNullable<
    Awaited<ReturnType<typeof setupStripeConnect>>
>;
export type SetupStripeConnectMutationBody = SetupStripeConnectBody;
export type SetupStripeConnectMutationError = APIErrorResponseResponse;

/**
 * @summary Setup Stripe Connect for a payment method
 */
export const useSetupStripeConnect = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setupStripeConnect>>,
        TError,
        { venueId: number; id: number; data: SetupStripeConnectBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof setupStripeConnect>>,
    TError,
    { venueId: number; id: number; data: SetupStripeConnectBody },
    TContext
> => {
    const mutationOptions = getSetupStripeConnectMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Public endpoint to start Stripe Connect onboarding for a payment method
 */
export const publicConnectOnboarding = (
    venueSlug: string,
    paymentMethodId: number,
    hash: string,
    publicConnectOnboardingBody: PublicConnectOnboardingBody,
    signal?: AbortSignal,
) => {
    return customInstance<PublicConnectOnboarding200>({
        url: `/public/connect-onboarding/${venueSlug}/${paymentMethodId}/${hash}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: publicConnectOnboardingBody,
        signal,
    });
};

export const getPublicConnectOnboardingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof publicConnectOnboarding>>,
        TError,
        {
            venueSlug: string;
            paymentMethodId: number;
            hash: string;
            data: PublicConnectOnboardingBody;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof publicConnectOnboarding>>,
    TError,
    { venueSlug: string; paymentMethodId: number; hash: string; data: PublicConnectOnboardingBody },
    TContext
> => {
    const mutationKey = ['publicConnectOnboarding'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof publicConnectOnboarding>>,
        {
            venueSlug: string;
            paymentMethodId: number;
            hash: string;
            data: PublicConnectOnboardingBody;
        }
    > = (props) => {
        const { venueSlug, paymentMethodId, hash, data } = props ?? {};

        return publicConnectOnboarding(venueSlug, paymentMethodId, hash, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PublicConnectOnboardingMutationResult = NonNullable<
    Awaited<ReturnType<typeof publicConnectOnboarding>>
>;
export type PublicConnectOnboardingMutationBody = PublicConnectOnboardingBody;
export type PublicConnectOnboardingMutationError = APIErrorResponseResponse;

/**
 * @summary Public endpoint to start Stripe Connect onboarding for a payment method
 */
export const usePublicConnectOnboarding = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof publicConnectOnboarding>>,
        TError,
        {
            venueSlug: string;
            paymentMethodId: number;
            hash: string;
            data: PublicConnectOnboardingBody;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof publicConnectOnboarding>>,
    TError,
    { venueSlug: string; paymentMethodId: number; hash: string; data: PublicConnectOnboardingBody },
    TContext
> => {
    const mutationOptions = getPublicConnectOnboardingMutationOptions(options);

    return useMutation(mutationOptions);
};
